import * as React from 'react'
import { Link as InternalLink } from 'widgets-for-react'
import { isMailPlusLink, toMpFormLink } from "./mailplus"

//  This function matches the url of a DrupalLink against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.
export type CustomLinkProps = {
  kind: "link"
  isLinkExternal: boolean
  target: "_blank" | "_self"
  url: string
  title: string
}

const isLinkExternal = (link: string): boolean => {
  // debugger
  if (link && link != '' && !link.startsWith('/')) {
    let currentUrlHost = window.location.host

    if ((link.toLowerCase().includes("https://") || link.toLowerCase().includes("http://")) && new URL(link).host != currentUrlHost) {
      return true;
    }

    return false;

    // let pattern = RegExp(`(http|https:\/\/(!?${currentUrlHost}/.*)|^\/.*)`, "gm");
    // const isExternal = !pattern.test(link);
    // return isExternal;
  } else {
    return false
  }
}

export const stripUrlToPath = (link: { title: string, url: string }): string => {
  let a = document.createElement("a")
  a.href = link.url
  return a.pathname
}

export const linkWrapper = (rawLink: { title: string, url: string }): CustomLinkProps => {
  const path = rawLink.url && stripUrlToPath(rawLink)
  const link = path.startsWith('/sites/') || isLinkExternal(rawLink.url) ? rawLink : { ...rawLink, url: path }
  return ({
    kind: 'link',
    isLinkExternal: isLinkExternal(link.url),
    target: isLinkExternal(link.url) ? '_blank' : '_self',
    title: link.title,
    url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link),
  })
}

export function LinkLayout(p: {
  link: CustomLinkProps,
  className: string,
  children: React.ReactNode | string,
  onClick?: () => void,
}): JSX.Element {
  return isLinkExternal(p.link.url) || p.link.target === '_blank' ? (
    <a
      href={p.link.url}
      className={p.className}
      title={p.link.title}
      onClick={p.onClick}
      target={p.link.target}
      rel={p.link.target === '_blank' ? 'noopener noreferrer' : ''}
    >
      {p.children}
    </a>
  ) : (
    <InternalLink
      to={p.link.url}
      className={p.className}
      title={p.link.title}
      onClick={p.onClick}
    >
      {p.children}
    </InternalLink>
  )
}



// New
//  This function matches the url against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.
export const isUrlExternal = (url: string): boolean => {
  if (url != '' && !url.startsWith('/')) {
    const currentUrlHost = window.location.host

    if (
      (url.toLowerCase().includes('https://') || url.toLowerCase().includes('http://')) &&
      new URL(url).host != currentUrlHost
    ) {
      return true
    }

    return false

    // let pattern = RegExp(`(http|https:\/\/(!?${currentUrlHost}/.*)|^\/.*)`, "gm");
    // const isExternal = !pattern.test(link);
    // return isExternal;
  } else {
    return false
  }
}

const isSPFileProxy = (url: string): boolean =>
  url.includes("/api/v1/sharepoint/file")

//TODO: dont lose query parameters when stripping down to path
// const stripUrlToPath = (url: string): string => {
//   let a = document.createElement('a')
//   a.href = url
//   return a.pathname
// }

export const Link = (
  props: {
    url: string
    children: React.ReactNode
    onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  } & Omit<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, 'href'>
) => {
  const handleClick = (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (props.onClick) props.onClick(e!)
    window.scrollTo(0, 0)
  }

  return isMailPlusLink(props.url) ? (
    <InternalLink {...props} to={toMpFormLink(props.url)} onClick={handleClick}>
      {props.children}
    </InternalLink>
  ) : isUrlExternal(props.url) ||
    isSPFileProxy(props.url) ||
    /.pdf$/.test(props.url) ||
    /.docx?$/.test(props.url) ||
    /.pptx?$/.test(props.url) ||
    /.xlsx?$/.test(props.url) ? (
    <a
      {...props}
      href={props.url}
      target="_blank"
      rel={props.rel ? props.rel : 'noopener noreferrer'}
      onClick={handleClick}
    >
      {props.children}
    </a>
  ) : (
    <InternalLink {...props} to={props.url} onClick={handleClick}>
      {props.children}
    </InternalLink>
  )
}
